'use client';
import { useSearchParams } from 'next/navigation';
/**
 * Tells whether the user is locked to the draw of an activated marketplace draw.
 *
 * A retailer that entered through an activated draw may only play that draw, so the draw selection
 * has to be hidden. Retailers without an activated draw in the URL keep access to all open draws.
 *
 * @param role the role of the current user
 * @returns true when the user may not change draw
 */
export function useIsLockedToActivatedDraw(role) {
    const searchParams = useSearchParams();
    return role === 'Retailer' && searchParams.get('activatedDrawId') !== null;
}
//# sourceMappingURL=useIsLockedToActivatedDraw.js.map